var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.716 12.845a5.704 5.704 0 0 1 0-8.156c2.287-2.252 5.996-2.252 8.284 0 2.288-2.252 5.997-2.252 8.284 0a5.704 5.704 0 0 1 0 8.156L12 21z"
})));
export { SvgIconHeartWhite as ReactComponent };